import type { CSSProperties } from "react";

export const PLANNER_ROW_HEIGHT = 44;
export const PLANNER_ROW_GAP = 4;
export const plannerRowStyle = {
  "--planner-row-height": `${PLANNER_ROW_HEIGHT}px`,
  "--planner-row-gap": `${PLANNER_ROW_GAP}px`,
} as CSSProperties;
